.sidebar {
    height: 100%;
    width: 380px;
    /* If changing, update the min width in lead-page.module.css and in header.module.css */
    min-width: 380px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    /* Unsure why margin bottom is being applied but this overwrites it */
    margin-bottom: 0;
}

/* Used for competitors & products create forms */
.select-create-form-row-icon {
    /* Same z-index as .icon in base-row.module.css */
    z-index: 2;
    flex-shrink: 0;
}
